import {cIO_MODBUS_ROOT} from "../modbus/modbusData";

// @ts-ignore
export const dummy_modbusdata: cIO_MODBUS_ROOT =
  {
    "cIO_MODBUS_WORLD": [{
      "Connection": {
        "name": "Net 0",
        "network": "10.0.0.29:502",
        "status": "online",
        "cIO_MODBUS_STATS": [{
          "STATS_ENUM": 1,
          "STATS_FAIL": 0,
          "STATS_SUCCESS": 0
        },
          {
            "STATS_ENUM": 2,
            "STATS_FAIL": 3,
            "STATS_SUCCESS": 14477576
          },
          {
            "STATS_ENUM": 3,
            "STATS_FAIL": 0,
            "STATS_SUCCESS": 0
          },
          {
            "STATS_ENUM": 4,
            "STATS_FAIL": 0,
            "STATS_SUCCESS": 68
          },
          {
            "STATS_ENUM": 5,
            "STATS_FAIL": 9,
            "STATS_SUCCESS": 43432482
          }
        ]
      },
      "cIO_MODBUS_TREE": [{
        "alarm": false,
        "brandcode": 12,
        "current": 50,
        "description": "Wand 1",
        "device": "ZiehlAbegg",
        "nodeerror": 0,
        "nodeerrorstr": "Ok",
        "nodeid": 1,
        "target": 60,
        "value": 60,
        "sensor1_type": 0,
        "sensor1_value": 0,
        "sensor2_type": 0,
        "sensor2_value": 0
      },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 80,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 2,
          "target": 70,
          "value": -70,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0
        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 100,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 3,
          "target": 80,
          "value": 30,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 4,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0
        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 6,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 7,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 8,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 1",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 5,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 9,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 10,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 11,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 12,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 14,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 15,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 16,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
        {
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 2",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 13,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        }
      ]
    },
      {
        "Connection": {
          "name": "Net 1",
          "network": "10.0.0.30:502",
          "status": undefined,
          "cIO_MODBUS_STATS": [{
            "STATS_ENUM": 1,
            "STATS_FAIL": 0,
            "STATS_SUCCESS": 0
          },
            {
              "STATS_ENUM": 2,
              "STATS_FAIL": 1,
              "STATS_SUCCESS": 14477592
            },
            {
              "STATS_ENUM": 3,
              "STATS_FAIL": 0,
              "STATS_SUCCESS": 0
            },
            {
              "STATS_ENUM": 4,
              "STATS_FAIL": 0,
              "STATS_SUCCESS": 84
            },
            {
              "STATS_ENUM": 5,
              "STATS_FAIL": 28,
              "STATS_SUCCESS": 43432470
            }
          ]
        },
        "cIO_MODBUS_TREE": [{
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 3",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 17,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0

        },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 18,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 19,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 20,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 22,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 23,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 24,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 3",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 21,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 25,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 26,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 27,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 28,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 30,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 31,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 32,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 4",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 29,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          }
        ]
      },
      {
        "Connection": {
          "name": "Net 2",
          "network": "10.0.0.31:502",
          "status": undefined,
          "cIO_MODBUS_STATS": [{
            "STATS_ENUM": 1,
            "STATS_FAIL": 0,
            "STATS_SUCCESS": 0
          },
            {
              "STATS_ENUM": 2,
              "STATS_FAIL": 2,
              "STATS_SUCCESS": 14477578
            },
            {
              "STATS_ENUM": 3,
              "STATS_FAIL": 0,
              "STATS_SUCCESS": 0
            },
            {
              "STATS_ENUM": 4,
              "STATS_FAIL": 0,
              "STATS_SUCCESS": 68
            },
            {
              "STATS_ENUM": 5,
              "STATS_FAIL": 13,
              "STATS_SUCCESS": 43432492
            }
          ]
        },
        "cIO_MODBUS_TREE": [{
          "alarm": false,
          "brandcode": 12,
          "current": 0,
          "description": "Wand 5",
          "device": "ZiehlAbegg",
          "nodeerror": 0,
          "nodeerrorstr": "Ok",
          "nodeid": 33,
          "target": 0,
          "value": 0,
          "sensor1_type": 0,
          "sensor1_value": 0,
          "sensor2_type": 0,
          "sensor2_value": 0


        },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 34,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 35,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 36,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 38,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 39,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 40,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0

          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 5",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 37,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 41,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 42,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 43,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 44,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 46,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 47,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 48,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          },
          {
            "alarm": false,
            "brandcode": 12,
            "current": 0,
            "description": "Wand 6",
            "device": "ZiehlAbegg",
            "nodeerror": 0,
            "nodeerrorstr": "Ok",
            "nodeid": 45,
            "target": 0,
            "value": 0,
            "sensor1_type": 0,
            "sensor1_value": 0,
            "sensor2_type": 0,
            "sensor2_value": 0


          }
        ]
      }
    ]
  }
